import { Component, inject, input, signal } from '@angular/core';
import { ShopService } from '../../services/shop.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { AuthService } from '../../../auth/services/auth.service';
import { ToastService } from '../../../shared/services/toast.service';
import { SharedService } from '../../../shared/services/shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'shop-carts',
  imports: [CurrencyPipe, DecimalPipe],
  templateUrl: './shop-carts.component.html',
})
export class ShopCartsComponent {

  router = inject(Router);

  authService = inject(AuthService);
  sharedService = inject(SharedService);
  shopService = inject(ShopService);
  toastService = inject(ToastService);


  goToCheckout(cartId: string) {

    this.router.navigate(['/main/shop/checkout', cartId]);

  }

 }
